var map = {
	"./dupdep": 7,
	"./dupdep.js": 7
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;



/*****************
 ** WEBPACK FOOTER
 ** ./compile/deduplication/dedupe2 ^\.\/dupd.*$
 ** module id = 6
 ** module chunks = 0
 **/